import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { VisuallyHidden } from "../VisuallyHidden/VisuallyHidden.js";
/* empty css          */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Alert/Alert.tsx
var TONE_ICON = {
	info: "info",
	success: "check-circle",
	warning: "alert-triangle",
	danger: "alert-circle"
};
var TONE_LABEL = {
	info: "Information",
	success: "Success",
	warning: "Warning",
	danger: "Error"
};
/**
* A persistent, page-level message. Danger and warning alerts are `role="alert"`;
* info and success are `role="status"`.
*/
function Alert({ tone = "info", icon = true, title, action, onDismiss, dismissLabel = "Dismiss", toneLabel = TONE_LABEL[tone], className, children, ...rest }) {
	const iconNode = icon === true ? /* @__PURE__ */ jsx(Icon, { name: TONE_ICON[tone] }) : icon === false ? null : icon;
	return /* @__PURE__ */ jsxs("div", {
		role: tone === "danger" || tone === "warning" ? "alert" : "status",
		className: cx("ds-alert", `ds-alert--${tone}`, className),
		...rest,
		children: [
			iconNode && /* @__PURE__ */ jsx("span", {
				className: "ds-alert__icon",
				"aria-hidden": "true",
				children: iconNode
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "ds-alert__main",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "ds-alert__content",
					children: [title && /* @__PURE__ */ jsxs("p", {
						className: "ds-alert__title",
						children: [/* @__PURE__ */ jsxs(VisuallyHidden, { children: [toneLabel, ": "] }), title]
					}), children && /* @__PURE__ */ jsxs("div", {
						className: "ds-alert__body",
						children: [!title && /* @__PURE__ */ jsxs(VisuallyHidden, { children: [toneLabel, ": "] }), children]
					})]
				}), action && /* @__PURE__ */ jsx("div", {
					className: "ds-alert__action",
					children: action
				})]
			}),
			onDismiss && /* @__PURE__ */ jsx("button", {
				type: "button",
				className: "ds-alert__close",
				"aria-label": dismissLabel,
				onClick: onDismiss,
				children: /* @__PURE__ */ jsx(Icon, { name: "x" })
			})
		]
	});
}
//#endregion
export { Alert };

//# sourceMappingURL=Alert.js.map